export const BASE_URL = 'https://x3z6xmnh8a.execute-api.us-east-2.amazonaws.com/dev/'

export const LOGIN = "admin/login/";
export const COMMUNITIES = "admin/communities/"